import { Box, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import Page from 'src/components/page/page';
import useOnboardingDetails from './onboarding-details.hook';
import CNLoading from 'src/components/loading-cn/CNLoading';
import OnboardingForm from './components/onboarding-form';

export default function OnboardingDetails() {
  const {
    isLoadingOnboarding,
    methods,
    isSubmitting,
    onboardingStagesFields,
    onSubmit,
    handleDropUrl,
    handleRemove,
    handleRemoveAll,
    appendOnboardingStage,
    removeOnboardingStage,
    handleDropStepImage,
    handleRemoveStepImage,
    handleRemoveAllStepImages,
  } = useOnboardingDetails();
  return (
    <Page title="Detalhe do onboarding">
      <Container>
        <HeaderBreadcrumbs heading="Editar Onboarding" links={[]} />
        {isLoadingOnboarding ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <OnboardingForm
            methods={methods}
            isSubmitting={isSubmitting}
            onSubmit={onSubmit}
            handleDropUrl={handleDropUrl}
            handleRemove={handleRemove}
            handleRemoveAll={handleRemoveAll}
            onboardingStagesFields={onboardingStagesFields}
            appendOnboardingStage={appendOnboardingStage}
            removeOnboardingStage={removeOnboardingStage}
            handleDropStepImage={handleDropStepImage}
            handleRemoveStepImage={handleRemoveStepImage}
            handleRemoveAllStepImages={handleRemoveAllStepImages}
          />
        )}
      </Container>
    </Page>
  );
}
